import rozcestnikZmenit from "../../content/rozcestnik/rozcestnikZmenit";
import { renderLoginComponent } from "../../components/Login";
import {initRozcestnikZapisy} from "./rozcestnikZapisyService";
import { initRozcestnik, callToast } from "./rozcestnikService";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikZmenit(isPublic) {
   
    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikZmenit());
    tilesDiv.style.display = "block";

    const divFormio = document.getElementById('divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);

    });

    const rozcestnikZapisy = document.getElementById('rozcestnikZapisy');
    rozcestnikZapisy.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikZapisy(isPublic);
    });

    const toastHranice = document.getElementById('toastHranice');
    if (toastHranice) toastHranice.addEventListener("click", event => {
        event.preventDefault();
        callToast("Změna hranice katastrálního území na žádost");
    });

    let rozcestnikZmenitS8414 = document.getElementById('rozcestnikZmenitS8414');

    if (isPublic) {
        rozcestnikZmenitS8414.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8414');
        });
    } else {
        rozcestnikZmenitS8414.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8414', null, null);
        });
    }

}
